export const SKELETON_TAG_HEIGHT = 18
